module.exports = __webpack_public_path__ + "img/second-day-13.b231a05a.webp";